<template>
  <div id="jobView">
    <div class="tit">{{subject}}</div>
    <div class="sub_tit">기업정보 상세</div>
    <div class="job_view_list">
      <div class="job_view_item">
        <div>기업명</div>
        <div>{{companyName}}</div>
      </div>
      <div class="job_view_item">
        <div>대표자명</div>
        <div>{{ceoName}}</div>
      </div>
      <div class="job_view_item">
        <div>업종</div>
        <div>{{businessType}}</div>
      </div>
      <div class="job_view_item">
        <div>사업내용</div>
        <div>{{businessDesc}}</div>
      </div>
      <div class="job_view_item">
        <div>소재지</div>
        <div>{{locationName}}</div>
      </div>
      <div class="job_view_item">
        <div>근로자 수</div>
        <div>{{employeeNum}}명</div>
      </div>
      <div class="job_view_item">
        <div>홈페이지</div>
        <div><a :href="homepage" target="_blank">{{homepage}}</a></div>
      </div>
    </div>
    <div class="sub_tit">채용정보 상세</div>
    <div class="job_view_list">
      <div class="job_view_item">
        <div>채용 공고명</div>
        <div>{{subject}}</div>
      </div>
      <div class="job_view_item">
        <div>고용형태</div>
        <div>
          <template v-if="employeeType === 'EMP01'">정규직</template>
          <template v-if="employeeType === 'EMP02'">계약직</template>
          <template v-if="employeeType === 'EMP03'">파견직</template>
          <template v-if="employeeType === 'EMP04'">시간제</template>
          <template v-if="employeeType === 'EMP05'">촉탁직</template>
          <template v-if="employeeType === 'EMP06'">기타</template>
        </div>
      </div>
      <div class="job_view_item">
        <div>급여</div>
        <div>
          <template v-if="salaryType === 'SAL01'">월급</template>
          <template v-if="salaryType === 'SAL02'">연봉</template>
          <template v-if="salaryType === 'SAL03'">시급</template>
          {{getNumberWithCommas(salary)}}원
        </div>
      </div>
      <div class="job_view_item">
        <div>모집인원</div>
        <div>{{getNumberWithCommas(recruitNum)}}명</div>
      </div>
      <div class="job_view_item">
        <div>모집직무</div>
        <div>{{recruitWork}}</div>
      </div>
      <div class="job_view_item">
        <div>모집부분 및 담당업무</div>
        <div>{{respWork}}</div>
      </div>
      <div class="job_view_item">
        <div>우대사항/자격요건</div>
        <div>{{premiumRequirement}}</div>
      </div>
      <div class="job_view_item">
        <div>경력유무</div>
        <div>
          <template v-if="careerType === 'CAR01'">경력직</template>
          <template v-if="careerType === 'CAR02'">신입</template>
          <template v-if="careerType === 'CAR03'">경력무관</template>
        </div>
      </div>
      <div class="job_view_item">
        <div>근무시간</div>
        <div><template v-if="workStart != null && workEnd != null">{{workStart.substring(0, 5)}} ~ {{workEnd.substring(0, 5)}}</template></div>
      </div>
      <div class="job_view_item">
        <div>근무지 상세</div>
        <div>{{locationDetail}}</div>
      </div>
      <div class="job_view_item">
        <div>복리후생</div>
        <div>
          <template v-if="benefit1">퇴직금</template>
          <template v-if="benefit2">식사제공</template>
          <template v-if="benefit3">퇴직연금</template>
          <template v-if="benefit4">상여금</template>
          <template v-if="benefit5">4대보험</template>
        </div>
      </div>
      <div class="job_view_item">
        <div>모집기간</div>
        <div><template v-if="recruitStart != null && recruitEnd != null">{{recruitStart}} ~ {{recruitEnd}}</template></div>
      </div>
    </div>
    <div class="common_bottom_wrap">
      <div class="btn_grey" @click="moveList">목록</div>
      <template v-if="this.mySession != null && this.mySession.userPid != null && this.mySession.userRole != null">
        <div class="btn_blue" @click="editJob">수정</div>
        <div class="btn_orange" @click="delJob">삭제</div>
      </template>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import job from '../../script/job'

export default {
  data () {
    return {
      // Common
      mySession: {},
      // Search
      searchParams: {},
      // Common Data
      hourMinuteList: common.getHourMinuteList(),
      // Data
      originData: {},
      jobPid: null,
      companyName: '', // 채용 회사명
      companyLogo: '', // 회사 로고. ci
      ceoName: '', // 대표자명
      employeeNum: '', // 근로자수
      businessType: '', // 업종
      businessDesc: '', // 사업내용
      locationName: '', // 소재지
      homepage: '', // 홈페이지
      subject: '', // 채용 공고명
      recruitStart: '', // 모집시작일
      recruitEnd: '', // 모집종료일
      dateRange: [],
      employeeType: '', // 고용형태
      salaryType: '', // 급여방식
      salary: '', // 급여
      recruitNum: '', // 모집인원
      recruitWork: '', // 모집직무
      respWork: '',
      premiumRequirement: '', // 우대사항/자격요건
      careerType: '', // 경력유무
      eduType: '', // 학력유무
      workStart: '', // 근무시작시간
      workEnd: '', // 근무종료시간
      locationDetail: '', // 근무지 상세
      benefits: '', // 복리후생
      benefit1: false,
      benefit2: false,
      benefit3: false,
      benefit4: false,
      benefit5: false
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      }
    })
    if (this.$route.params != null) {
      if (this.$route.params.searchParams != null) {
        this.searchParams = this.$route.params.searchParams
      }
      if (this.$route.params.data != null && this.$route.params.data.jobPid != null) {
        this.setJob(this.$route.params.data)
      }
    }
  },
  methods: {
    getNumberWithCommas (value) {
      return common.getNumberWithCommas(value)
    },
    setJob (data) {
      console.log(data)
      this.originData = data
      this.jobPid = data.jobPid
      this.companyName = data.companyName
      this.ceoName = data.ceoName
      this.employeeNum = data.employeeNum
      this.businessType = data.businessType
      this.businessDesc = data.businessDesc
      this.locationName = data.locationName
      this.homepage = data.homepage
      this.subject = data.subject
      this.recruitStart = data.recruitStart
      this.recruitEnd = data.recruitEnd
      this.dateRange = [new Date(data.recruitStart), new Date(data.recruitEnd)]
      this.eduType = data.eduType
      this.employeeType = data.employeeType
      this.salaryType = data.salaryType
      this.salary = data.salary
      this.recruitNum = data.recruitNum
      this.recruitWork = data.recruitWork
      this.respWork = data.respWork
      this.premiumRequirement = data.premiumRequirement
      this.careerType = data.careerType
      this.workStart = data.workStart
      this.workEnd = data.workEnd
      this.locationDetail = data.locationDetail
      this.benefits = data.benefits
      this.benefit1 = false
      this.benefit2 = false
      this.benefit3 = false
      this.benefit4 = false
      this.benefit5 = false
      let benefits = data.benefits
      if (benefits != null && benefits.length > 0 && benefits.split(',').length === 5) {
        const item = benefits.split(',')
        this.benefit1 = JSON.parse(item[0])
        this.benefit2 = JSON.parse(item[1])
        this.benefit3 = JSON.parse(item[2])
        this.benefit4 = JSON.parse(item[3])
        this.benefit5 = JSON.parse(item[4])
      }
    },
    moveList () {
      this.$router.push({
        name: 'JobList',
        params: {
          searchParams: this.searchParams
        }
      })
    },
    editJob () {
      this.$router.push({
        name: 'JobForm',
        params: {
          searchParams: this.searchParams,
          data: this.originData
        }
      })
    },
    delJob () {
      if (confirm('정말 삭제하시겠습니다?')) {
        job.job('delete', {
          jobPid: this.originData.jobPid
        }, response => {
          console.log('채용정보 삭제', response)
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '채용정보를 삭제했습니다.')
            this.moveList()
          } else {
            common.amsAlert('retry', '채용정보를 삭제하지 못했습니다.')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
#jobView {
  text-align: left;
}

.mobile_wrap #jobView {
  padding: 0 16px;
  box-sizing: border-box;
}

#jobView > .tit {
  margin-top: 55px;
  color: #0F1015;
  font-size: 24px;
  font-weight: 700;
}

.mobile_wrap #jobView > .tit {
  margin-top: 40px;
  font-size: 18px;
}

#jobView > .sub_tit {
  height: 68px;
  border-top: 3px solid #000000;
  margin-top: 30px;
  box-sizing: border-box;
  color: #0F1015;
  font-size: 16px;
  font-weight: 500;
  line-height: 65px;
}

.mobile_wrap #jobView > .sub_tit {
  height: 48px;
  margin-top: 18px;
  font-size: 14px;
  line-height: 45px;
}

#jobView > .job_view_list {
  display: flex;
  flex-direction: column;
}

#jobView > .job_view_list > .job_view_item {
  display: flex;
  height: 50px;
}

#jobView > .job_view_list > .job_view_item:nth-child(odd) {
  background: #F8F8F8;
}

#jobView > .job_view_list > .job_view_item:last-child {
  border-bottom: 1px solid #000000;
}

#jobView > .job_view_list > .job_view_item > div {
  margin: auto 0;
  color: #36414F;
  font-size: 14px;
  font-weight: 500;
}

#jobView > .job_view_list > .job_view_item > div:nth-child(1) {
  width: 200px;
  text-align: center;
}

.mobile_wrap #jobView > .job_view_list > .job_view_item > div:nth-child(1) {
  width: 100px;
  padding: 0 8px;
  box-sizing: border-box;
  text-align: center;
  word-break: keep-all;
}

#jobView > .job_view_list > .job_view_item > div:nth-child(2) {
}
</style>



// WEBPACK FOOTER //
// src/components/job/View.vue